import { formatDate} from "@/libs/util";
const mixin =  {
  methods:{
    formatDate
  }
}
export const globalMixin = mixin
